import { connect } from "react-redux"

import { getCurrentUser } from "../../auth/selectors/currentUserGetters"
import { createErrorNotification } from "../../notifications/actions/createErrorNotification"
import { createSuccessNotification } from "../../notifications/actions/createSuccessNotification"
import withPageTitle from "../../routes/containers/withPageTitle"
import { State } from "../../store"
import ContactForm from "../components/ContactForm"

const mapStateToProps = (state: State) => ({
  user: getCurrentUser(state),
})

const mapDispatchToProps = {
  onSuccess: createSuccessNotification,
  onFailure: createErrorNotification,
}

export default withPageTitle("Contact Us")(
  connect(mapStateToProps, mapDispatchToProps)(ContactForm)
)
